import React, { PropTypes,  Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as toursActions from '../actions/tours';
import Reviews from '../components/tour/Reviews';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { Link } from 'react-router';
import Helmet from "react-helmet";
import Translate from '../components/layout/Translate';
import * as userActions from '../actions/user';

class ReviewsPage extends Component {

    componentDidMount() {
        this.props.toursActions.fetchAllReviews(1);
    }

    componentWillUnmount() {


    }

    render () {

        let {reviews, openedReviews, translations, seo, reviewsPopupOpen, reviewsLang} = this.props;
        let meta = [
            {"name": "description", "content": (seo.description)?seo.description:""}
        ];

        return (

            <section className="section reviews-page">

                <Helmet
                    title={(seo.title)?seo.title:translations.reviews__title_all}
                    meta={meta}
                />

                <Header />
                <div className="container promo">
                    <h1><Translate slug="reviews__title_all" /></h1>
                    <div className="container__description">
                        <div className="page__content">
                            <Reviews
                                reviews={reviews}
                                openedReviews={openedReviews}
                                reviewsLang={reviewsLang}
                                reviewsPopupOpen={reviewsPopupOpen}
                                reviewsPageCount={this.props.reviewsPageCount}
                                fetchReviews={this.props.fetchReviews}
                                lang={this.props.lang}
                                userActions={this.props.userActions}
                                actions={this.props.toursActions}
                                list={true}
                            />


                        </div>
                    </div>
                    <div className="footer__registration">
                        <Translate
                            slug="main__registration"/>
                    </div>
                </div>
            </section>
        );
    }
}


ReviewsPage.need = [
    {
        action: toursActions.fetchAllReviews
    }
];


function mapStateToProps (state) {
    return {
        reviews: state.tours.reviews,
        openedReviews: state.tours.openedReviews,
        fetchReviews: state.tours.fetchReviews,
        lang: state.user.lang,
        translations: state.user.translations,
        reviewsPageCount: state.tours.reviewsPageCount,
        reviewsPopupOpen: state.user.reviewsPopupOpen,
        reviewsLang: state.tours.reviewsLang,
        seo: state.user.seo
    }
}

function mapDispatchToProps (dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewsPage)




// WEBPACK FOOTER //
// ./src/common/containers/ReviewsPage.js